import { useMemo } from "react";
import { useQuery } from "@apollo/client/react/hooks/useQuery";
import { Query, featuredCardsAaaGql } from "@onmo/graphql/graphql";
import { GUIDE_VIDEOS_GROUP } from "../constants/videos";
import { findCardRedirectUrl } from "../models/guideVideos";

export const useGuideVideo = (id: string): string => {
  const { data } = useQuery<Query>(featuredCardsAaaGql, {
    variables: { input: { group: GUIDE_VIDEOS_GROUP } },
  });

  return useMemo(() => findCardRedirectUrl(data, id), [data, id]);
};
